import React from 'react';
import qs from 'qs';

import ArrowSvg from '../../../reusable-components/icons/ArrowSvg';
import client from '../../../utils/client';
import smoothScroll from '../../../utils/smoothScroll';

import './cartCta.scss';

const CartCta = (props) => {
  const returnErrorMessage = () => {
    const { product_id, price } = props;
    if (product_id === '' && price === '') return props.err3;
    if (product_id === '') return props.err1;
    if (price === '') return props.err2;
    return null;
  };

  const hasToScroll = () => {
    return smoothScroll('input-error', 250);
  };

  const addToCart = (product_id, price) => {
    return client.post('/cart/items/add_to_cart/', qs.stringify({
      product_id,
      price,
      size: 191,
    }))
    .then((response) => { window.location.href = response.data.customization_url; })
    .catch(() => {
      /**/
    });
  };

  const handleOnClick = () => {
    const { price, product_id } = props;
    const err = document.getElementById('gc-error-message');
    const errMsg = returnErrorMessage();
    if (errMsg !== null) {
      err.innerText = errMsg;
    } else if (!props.amountValid) {
      err.innerText = '';
      hasToScroll();
    } else {
      addToCart(product_id, price);
    }
  };

  return (
    <div className="cta-wrapper">
      <button
        className="cart_cta"
        type="button"
        onClick={() => handleOnClick()}
      >
        {props.title}
        <ArrowSvg direction="next" />
      </button>
      <p id="gc-error-message" />
    </div>
  );
};

export default CartCta;
